import React, { useEffect, useState, useRef } from 'react';
import pb from '../pocketbase';
import { useNavigate } from 'react-router-dom';
import {
    FaFileUpload, FaTrash, FaTimes, FaCheck, FaCamera, FaFileInvoice,
    FaList, FaCalendarAlt, FaChartBar, FaUsers, FaBell, FaUserEdit,
    FaPaperPlane, FaSave, FaTools, FaMapMarkedAlt, FaMobileAlt,
    FaComments, FaDownload, FaImages, FaCheckSquare, FaSquare, FaPlus,
    FaStar, FaCloudUploadAlt, FaTh, FaArrowUp, FaArrowDown, FaGripVertical,
    FaChartPie, FaBriefcase, FaCog, FaHistory, FaQrcode, FaSun, FaMoon, FaArrowLeft, FaSearch
} from 'react-icons/fa';
import { QRCodeCanvas } from 'qrcode.react';
import { motion, AnimatePresence, Reorder, useDragControls } from 'framer-motion';
import { notifyBookingConfirmed } from '../services/notificationService';


import AdminCalendar from '../components/AdminCalendar';
import AdminDashboard from '../components/AdminDashboard';
import AdminServices from '../components/AdminServices';
import AdminMap from '../components/AdminMap';
import AdminChat from '../components/AdminChat';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './AdminPage.css';

const AdminPage = () => {
    const navigate = useNavigate();
    const user = pb.authStore.model;
    const [appointments, setAppointments] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    // View State
    const [currentView, setCurrentView] = useState('dashboard');

    // Search & Filter State
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');

    // CRM State
    const [editingUser, setEditingUser] = useState(null);
    const [bonusPoints, setBonusPoints] = useState(0);
    const [viewingApt, setViewingApt] = useState(null);

    // File Management State
    const [selectedApt, setSelectedApt] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [filesValues, setFilesValues] = useState({ photos: [], facture: null });
    const [gallerySelection, setGallerySelection] = useState([]); // For Gallery Generator

    // Project Creation State (REALISATIONS)
    const [projects, setProjects] = useState([]); // New state for realisations collection
    const [isCreatingProject, setIsCreatingProject] = useState(false);
    const [editingProject, setEditingProject] = useState(null);
    const [newProjectData, setNewProjectData] = useState({
        client_nom: '',
        prestation: '', // Will map to 'titre'
        date_heure: new Date().toISOString().slice(0, 16),
        project_category: 'auto', // Will map to 'categorie'
        publier_home: true,
        photo_pairs: [{ id: Date.now(), avant: null, apres: null, typeAvant: 'new', typeApres: 'new' }],
        liste_avant: '',
        liste_apres: '',
        interventions: '',
        tags: '',
        photos_to_remove: []
    });

    // Theme & Navbar State
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    const [isNotifOpen, setIsNotifOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isQrOpen, setIsQrOpen] = useState(false);
    const notifRef = useRef(null);
    const userMenuRef = useRef(null);

    useEffect(() => {
        document.body.className = theme === 'dark' ? 'dark-mode' : '';
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
    };

    // Close Dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notifRef.current && !notifRef.current.contains(event.target)) {
                setIsNotifOpen(false);
            }
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setIsUserMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const logout = () => {
        pb.authStore.clear();
        navigate('/');
    };

    // Planning & Closures State
    const [weekPlanning, setWeekPlanning] = useState([]);
    const [blockedDays, setBlockedDays] = useState([]);
    const [newBlockedPeriod, setNewBlockedPeriod] = useState({ dateDebut: '', dateFin: '', raison: '' });
    const [blockedTab, setBlockedTab] = useState('upcoming');

    // Signature State
    const [signingApt, setSigningApt] = useState(null);
    const canvasRef = React.useRef(null);

    const compressImage = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 1200;
                    const MAX_HEIGHT = 1200;
                    let width = img.width;
                    let height = img.height;

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height;
                            height = MAX_HEIGHT;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob((blob) => {
                        resolve(new File([blob], file.name, {
                            type: 'image/jpeg',
                            lastModified: Date.now(),
                        }));
                    }, 'image/jpeg', 0.7); // 70% quality
                };
            };
        });
    };


    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const addPhotoPair = () => {
        setNewProjectData(prev => ({
            ...prev,
            photo_pairs: [...prev.photo_pairs, { id: Date.now() + Math.random(), avant: null, apres: null, typeAvant: 'new', typeApres: 'new' }]
        }));
    };

    const removePhotoPair = (id) => {
        const pair = newProjectData.photo_pairs.find(p => p.id === id);
        if (pair) {
            const toRemove = [];
            if (pair.typeAvant === 'existing' && pair.avant) toRemove.push({ field: 'photo_avant', filename: pair.avant });
            if (pair.typeApres === 'existing' && pair.apres) toRemove.push({ field: 'photo_apres', filename: pair.apres });

            setNewProjectData(prev => ({
                ...prev,
                photo_pairs: prev.photo_pairs.filter(p => p.id !== id),
                photos_to_remove: [...prev.photos_to_remove, ...toRemove]
            }));
        }
    };

    const updatePairFile = async (id, side, file) => {
        if (!file) return;
        const compressed = await compressImage(file);
        setNewProjectData(prev => ({
            ...prev,
            photo_pairs: prev.photo_pairs.map(p => {
                if (p.id === id) {
                    return { ...p, [side]: compressed, [`type${side.charAt(0).toUpperCase() + side.slice(1)}`]: 'new' };
                }
                return p;
            })
        }));
    };

    const removeFileFromPair = (id, side) => {
        const pair = newProjectData.photo_pairs.find(p => p.id === id);
        const typeKey = `type${side.charAt(0).toUpperCase() + side.slice(1)}`;

        if (pair[typeKey] === 'existing' && pair[side]) {
            setNewProjectData(prev => ({
                ...prev,
                photos_to_remove: [...prev.photos_to_remove, { field: `photo_${side}`, filename: pair[side] }],
                photo_pairs: prev.photo_pairs.map(p => p.id === id ? { ...p, [side]: null, [typeKey]: 'new' } : p)
            }));
        } else {
            setNewProjectData(prev => ({
                ...prev,
                photo_pairs: prev.photo_pairs.map(p => p.id === id ? { ...p, [side]: null, [typeKey]: 'new' } : p)
            }));
        }
    };

    const handleEditProject = (proj) => {
        setEditingProject(proj);
        setNewProjectData({
            client_nom: proj.client_nom || '',
            prestation: proj.titre || '',
            date_heure: proj.date ? new Date(proj.date).toISOString().slice(0, 16) : new Date().toISOString().slice(0, 16),
            project_category: proj.categorie || 'auto',
            publier_home: proj.publier_home || false,
            liste_avant: proj.liste_avant || '',
            liste_apres: proj.liste_apres || '',
            interventions: proj.interventions || '',
            tags: proj.tags || '',
            photo_pairs: (() => {
                const avants = Array.isArray(proj.photo_avant) ? proj.photo_avant : (proj.photo_avant ? [proj.photo_avant] : []);
                const apres = Array.isArray(proj.photo_apres) ? proj.photo_apres : (proj.photo_apres ? [proj.photo_apres] : []);
                const max = Math.max(avants.length, apres.length);
                const pairs = [];
                for (let i = 0; i < max; i++) {
                    pairs.push({
                        id: i,
                        avant: avants[i] || null,
                        apres: apres[i] || null,
                        typeAvant: avants[i] ? 'existing' : 'new',
                        typeApres: apres[i] ? 'existing' : 'new'
                    });
                }
                return pairs.length > 0 ? pairs : [{ id: Date.now(), avant: null, apres: null, typeAvant: 'new', typeApres: 'new' }];
            })(),
            photos_to_remove: []
        });
        setIsCreatingProject(true);
    };


    const handleCreateProject = async (e) => {
        e.preventDefault();
        setUploading(true);

        const formData = new FormData();
        // Mapping to 'realisations' collection fields
        formData.append('titre', newProjectData.prestation); // 'prestation' input maps to 'titre'
        formData.append('client_nom', newProjectData.client_nom);

        // Date handling
        const dateObj = newProjectData.date_heure ? new Date(newProjectData.date_heure) : new Date();
        formData.append('date', dateObj.toISOString());

        formData.append('categorie', newProjectData.project_category);
        formData.append('publier_home', newProjectData.publier_home.toString());
        formData.append('liste_avant', newProjectData.liste_avant || '');
        formData.append('liste_apres', newProjectData.liste_apres || '');
        formData.append('interventions', newProjectData.interventions || '');
        formData.append('tags', newProjectData.tags || '');

        // Process Photo Pairs
        for (const pair of newProjectData.photo_pairs) {
            if (pair.avant && pair.typeAvant === 'new') {
                formData.append('photo_avant', pair.avant);
            }
            if (pair.apres && pair.typeApres === 'new') {
                formData.append('photo_apres', pair.apres);
            }
        }

        try {
            await pb.collection('realisations').create(formData);
            alert("Réalisation créée avec succès !");
            setIsCreatingProject(false);
            setNewProjectData({
                client_nom: '',
                prestation: '',
                date_heure: new Date().toISOString().slice(0, 16),
                project_category: 'auto',
                publier_home: true,
                photo_pairs: [{ id: Date.now(), avant: null, apres: null, typeAvant: 'new', typeApres: 'new' }],
                liste_avant: '',
                liste_apres: '',
                interventions: '',
                tags: '',
                photos_to_remove: []
            });
            loadProjects(); // Reload projects list
        } catch (err) {
            console.error("Error creating realisation:", err);
            alert(`Erreur lors de la création: ${err.message}`);
        } finally {
            setUploading(false);
        }
    };

    const handleUpdateProject = async (e) => {
        e.preventDefault();
        if (!editingProject) return;
        setUploading(true);

        const formData = new FormData();
        formData.append('titre', newProjectData.prestation);
        formData.append('client_nom', newProjectData.client_nom);

        const dateObj = new Date(newProjectData.date_heure);
        formData.append('date', dateObj.toISOString());

        formData.append('categorie', newProjectData.project_category);
        formData.append('publier_home', newProjectData.publier_home.toString());
        formData.append('liste_avant', newProjectData.liste_avant || '');
        formData.append('liste_apres', newProjectData.liste_apres || '');
        formData.append('interventions', newProjectData.interventions || '');
        formData.append('tags', newProjectData.tags || '');

        // Marks files for deletion using PocketBase "-" modifier
        if (newProjectData.photos_to_remove && newProjectData.photos_to_remove.length > 0) {
            newProjectData.photos_to_remove.forEach(item => {
                formData.append(`${item.field}-`, item.filename);
            });
        }

        // Process Photo Pairs (Existing filenames to keep + New File objects)
        for (const pair of newProjectData.photo_pairs) {
            if (pair.avant) {
                formData.append('photo_avant', pair.avant);
            }
            if (pair.apres) {
                formData.append('photo_apres', pair.apres);
            }
        }


        try {
            await pb.collection('realisations').update(editingProject.id, formData);
            alert("Réalisation mise à jour !");
            setIsCreatingProject(false);
            setEditingProject(null);
            setNewProjectData({
                client_nom: '',
                prestation: '',
                date_heure: new Date().toISOString().slice(0, 16),
                project_category: 'auto',
                publier_home: true,
                photo_pairs: [{ id: Date.now(), avant: null, apres: null, typeAvant: 'new', typeApres: 'new' }],
                liste_avant: '',
                liste_apres: '',
                interventions: '',
                tags: '',
                photos_to_remove: []
            });
            loadProjects();
        } catch (err) {
            console.error("Error updating realisation:", err);
            alert(`Erreur lors de la mise à jour: ${err.message}`);
        } finally {
            setUploading(false);
        }
    };


    const getRemindersTomorrow = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const tomStr = tomorrow.toISOString().split('T')[0];

        return appointments.filter(apt => {
            const aptDate = apt.date_heure.split('T')[0];
            return aptDate === tomStr && (apt.statut === 'valide' || apt.statut === 'en_attente');
        });
    };

    const getReviewRequests = () => {
        const twoDaysAgo = new Date();
        twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
        const dateStr = twoDaysAgo.toISOString().split('T')[0];

        return appointments.filter(apt => {
            const aptDate = apt.date_heure.split('T')[0];
            return aptDate === dateStr && (apt.statut === 'termine' || apt.statut === 'valide');
        });
    };

    const getDormantClients = () => {
        const ninetyDaysAgo = new Date();
        ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

        // Group by client and find the latest 'termine' appointment
        const latestByClient = {};
        appointments.forEach(apt => {
            if (apt.statut !== 'termine') return;
            const email = apt.client_email;
            const date = new Date(apt.date_heure);
            if (!latestByClient[email] || date > latestByClient[email].date) {
                latestByClient[email] = {
                    date,
                    name: apt.client_nom,
                    tel: apt.client_telephone,
                    prestation: apt.prestation
                };
            }
        });

        // Filter those whose latest appointment is > 90 days ago
        return Object.values(latestByClient).filter(client => client.date < ninetyDaysAgo);
    };

    const sendWhatsApp = (tel, message) => {
        // Clean phone number (remove spaces, etc.)
        const cleanTel = tel.replace(/\s/g, '');
        window.open(`https://wa.me/${cleanTel}/?text=${encodeURIComponent(message)}`, '_blank');
    };

    useEffect(() => {
        if (!user || user.role !== 'admin') {
            navigate('/');
            return;
        }
        loadData();
    }, [user?.id, navigate]);

    useEffect(() => {
        if (currentView === 'crm') loadUsers();
    }, [currentView]);

    const loadData = async () => {
        try {
            // Load Appointments
            const aptRecords = await pb.collection('rendez_vous').getList(1, 200, { sort: '-date_heure' });
            setAppointments(aptRecords.items);

            // Load Projects (Realisations)
            await loadProjects();

            // Load Planning & Closures
            await loadPlanningData();

            setLoading(false);
        } catch (err) {
            if (err.isAbort) return; // Ignore autocancellation
            console.error("Erreur chargement données", err);
            setLoading(false);
        }
    };

    const loadPlanningData = async () => {
        try {
            const plan = await pb.collection('planning').getFullList({ sort: 'created' }); // Order as created (Mon-Sun)
            setWeekPlanning(plan);

            const closures = await pb.collection('fermetures').getFullList({ sort: '-date' });
            setBlockedDays(closures);
        } catch (err) { console.error("Planning Load Error", err); }
    };

    const saveDayConfig = async (dayId, data) => {
        try {
            await pb.collection('planning').update(dayId, data);
            loadPlanningData();
        } catch (err) { alert("Erreur sauvegarde horaires"); }
    };

    const applyMondayToAll = () => {
        const monday = weekPlanning.find(d => d.jour === 'Lundi');
        if (!monday) return;
        const updated = weekPlanning.map(day => ({
            ...day,
            debut: monday.debut,
            fin: monday.fin,
            ouvert: monday.ouvert
        }));
        setWeekPlanning(updated);
    };

    const saveAllPlanning = async () => {
        setUploading(true);
        try {
            await Promise.all(weekPlanning.map(day =>
                pb.collection('planning').update(day.id, {
                    debut: day.debut,
                    fin: day.fin,
                    ouvert: day.ouvert
                })
            ));
            alert("Tous les horaires ont été enregistrés ! ✨");
            loadPlanningData();
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'enregistrement groupé.");
        } finally {
            setUploading(false);
        }
    };

    const initPlanning = async () => {
        const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
        try {
            for (const day of days) {
                await pb.collection('planning').create({
                    jour: day,
                    ouvert: day !== 'Dimanche', // Closed on Sunday by default
                    debut: '09:00',
                    fin: '18:00'
                });
            }
            alert("Planning initialisé !");
            loadPlanningData();
        } catch (err) { alert("Erreur initialisation. Vérifiez que la collection 'planning' existe."); }
    };

    const handleBlockPeriod = async (e) => {
        e.preventDefault();
        try {
            const start = new Date(newBlockedPeriod.dateDebut);
            const end = newBlockedPeriod.dateFin ? new Date(newBlockedPeriod.dateFin) : new Date(start);

            if (end < start) return alert("La date de fin doit être après la date de début.");

            // Conflict Detection
            const startStr = start.toISOString().split('T')[0];
            const endStr = end.toISOString().split('T')[0];

            const conflicts = appointments.filter(apt => {
                const aptDate = apt.date_heure.split('T')[0];
                return aptDate >= startStr && aptDate <= endStr && (apt.statut === 'valide' || apt.statut === 'en_attente');
            });

            if (conflicts.length > 0) {
                const proceed = window.confirm(`Attention ! Il y a ${conflicts.length} rendez-vous déjà réservés sur cette période. Voulez-vous quand même bloquer ?`);
                if (!proceed) return;
            }

            setUploading(true);
            let current = new Date(start);
            const promises = [];

            // Get existing dates for faster lookup
            const existingDates = new Set(blockedDays.map(b => new Date(b.date).toLocaleDateString('fr-CA')));

            while (current <= end) {
                const dateString = current.toLocaleDateString('fr-CA'); // YYYY-MM-DD

                if (!existingDates.has(dateString)) {
                    promises.push(pb.collection('fermetures').create({
                        date: current.toISOString(),
                        raison: newBlockedPeriod.raison
                    }, { requestKey: null }));
                    // Add to set to prevent duplicates within the same batch if current logic was flawed
                    existingDates.add(dateString);
                }
                current.setDate(current.getDate() + 1);
            }

            if (promises.length > 0) {
                await Promise.all(promises);
                alert(`${promises.length} jour(s) bloqué(s) avec succès !`);
            } else {
                alert("Ces dates sont déjà bloquées.");
            }

            setNewBlockedPeriod({ dateDebut: '', dateFin: '', raison: '' });
            loadPlanningData();
            alert("Période bloquée avec succès !");
        } catch (err) {
            console.error(err);
            alert("Erreur lors du blocage de la période");
        } finally {
            setUploading(false);
        }
    };

    const unblockDate = async (id) => {
        if (!window.confirm("Débloquer cette date ?")) return;
        try {
            await pb.collection('fermetures').delete(id);
            loadPlanningData();
        } catch (err) { alert("Erreur suppression"); }
    };

    const handleMoveProject = async (proj, direction) => {
        const index = projects.findIndex(p => p.id === proj.id);
        if (direction === 'up' && index === 0) return;
        if (direction === 'down' && index === projects.length - 1) return;

        const targetIndex = direction === 'up' ? index - 1 : index + 1;
        const targetProj = projects[targetIndex];

        try {
            // Simple swap of ordre values. 
            // We use the index as a fallback if ordre is not set yet.
            const currentOrdre = proj.ordre !== undefined ? proj.ordre : index;
            const targetOrdre = targetProj.ordre !== undefined ? targetProj.ordre : targetIndex;

            await pb.collection('realisations').update(proj.id, { ordre: targetOrdre });
            await pb.collection('realisations').update(targetProj.id, { ordre: currentOrdre });

            loadProjects();
        } catch (err) {
            console.error("Error moving project:", err);
            alert("Erreur: Le champ 'ordre' (type: nombre) est-il bien présent sur PocketBase ?");
        }
    };

    const saveNewOrder = async (newOrderedList) => {
        setProjects(newOrderedList);
        // Persist order to database
        try {
            for (let i = 0; i < newOrderedList.length; i++) {
                const proj = newOrderedList[i];
                if (proj.ordre !== i) {
                    await pb.collection('realisations').update(proj.id, { ordre: i });
                }
            }
        } catch (err) {
            console.error("Error saving new order:", err);
        }
    };

    const loadProjects = async () => {
        try {
            // Sort by 'ordre' ascending, then by creation date
            const records = await pb.collection('realisations').getList(1, 100, { sort: 'ordre,-created' });
            setProjects(records.items);
        } catch (err) {
            if (err.isAbort) return;
            console.error("Erreur chargement réalisations", err);
        }
    };

    const loadUsers = async () => {
        try {
            console.log("DEBUG - Début chargement users...");
            const records = await pb.collection('users').getFullList({
                sort: '-created',
                requestKey: null
            });
            console.log("DEBUG - Users reçus:", records);
            setUsers(records);
        } catch (err) {
            if (err.isAbort) return;
            console.error("Erreur chargement users", err);
        }
    };

    const updateStatus = async (id, status) => {
        if (status === 'termine') {
            const apt = appointments.find(a => a.id === id);
            setSigningApt(apt);
            return;
        }

        if (!window.confirm(`Passer ce RDV en ${status} ?`)) return;
        try {
            const updated = await pb.collection('rendez_vous').update(id, { statut: status });

            if (status === 'valide') {
                notifyBookingConfirmed(updated);
            }

            loadData();
        } catch (err) { alert("Erreur maj statut"); }
    };

    const handleTerminate = async () => {
        if (!signingApt) return;

        try {
            setUploading(true);
            // On génère la facture sans signature
            const pdfBlob = await generateInvoiceBlob(signingApt);

            const formData = new FormData();
            formData.append('statut', 'termine');
            formData.append('facture', pdfBlob, `Facture_${signingApt.client_nom}.pdf`);

            await pb.collection('rendez_vous').update(signingApt.id, formData, { requestKey: null });

            alert("Rendez-vous clôturé avec succès !");
            setSigningApt(null);
            setUploading(false);
            loadData();
        } catch (err) {
            console.error("DEBUG - Erreur clôture complète:", err);
            
            // Extraction des détails de l'erreur PocketBase
            let detail = "";
            if (err.response && err.response.data) {
                detail = Object.entries(err.response.data)
                    .map(([key, value]) => `${key}: ${value.message || JSON.stringify(value)}`)
                    .join(", ");
            }
            
            alert(`Erreur lors de la clôture : ${err.message} ${detail ? `(${detail})` : ""}`);
            setUploading(false);
        }
    };

    const generateInvoiceBlob = async (apt) => {
        const doc = new jsPDF();

        // Header
        doc.setFontSize(22);
        doc.setTextColor(37, 99, 235);
        doc.text("RoulezPropre", 20, 20);

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text("Facture Professionnelle", 20, 26);
        doc.text(`Facture N°: ${apt.id.slice(0, 8).toUpperCase()}`, 150, 20);
        doc.text(`Date: ${new Date().toLocaleDateString()}`, 150, 26);

        // Client & Business Info
        doc.setFontSize(12);
        doc.setTextColor(0);
        doc.text("Prestataire :", 20, 45);
        doc.setFont("helvetica", "normal");
        doc.text("RoulezPropre Nettoyage", 20, 52);
        doc.text("Contact: roulezpropre@gmail.com", 20, 58);

        doc.text("Client :", 120, 45);
        doc.text(`${apt.client_nom}`, 120, 52);
        doc.text(`${apt.client_email}`, 120, 58);
        doc.text(`${apt.client_telephone}`, 120, 64);

        // Nettoyage du prix (au cas où il y ait "€" ou des espaces dans la chaîne)
        const rawPrice = apt.prix ? String(apt.prix).replace(/[^0-9.,]/g, '').replace(',', '.') : "0";
        const numericPrice = parseFloat(rawPrice) || 0;

        // Table
        autoTable(doc, {
            startY: 80,
            head: [['Description de la prestation', 'Prix HT', 'TVA (20%)', 'Total TTC']],
            body: [
                [
                    apt.prestation || "Prestation de nettoyage",
                    `${(numericPrice * 0.833).toFixed(2)} €`,
                    `${(numericPrice * 0.167).toFixed(2)} €`,
                    `${numericPrice.toFixed(2)} €`
                ],
            ],
            theme: 'striped',
            headStyles: { fillColor: [37, 99, 235] }
        });

        const finalY = (doc).lastAutoTable ? (doc).lastAutoTable.finalY + 15 : 100;
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(`TOTAL NET À PAYER : ${numericPrice.toFixed(2)} €`, 120, finalY);

        return doc.output('blob');
    };

    // --- CRM Logic ---
    const handleEditUser = (user) => {
        setEditingUser(user.id);
        setBonusPoints(user.points_bonus || 0);
    };

    const saveBonusPoints = async (userId) => {
        try {
            await pb.collection('users').update(userId, { points_bonus: bonusPoints });
            setEditingUser(null);
            loadUsers();
            alert("Points mis à jour !");
        } catch (err) { alert("Erreur maj points"); }
    };

    // --- Filter Logic ---
    const filteredAppointments = appointments.filter(apt => {
        const matchesSearch = (
            (apt.client_nom?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
            (apt.client_email?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
            (apt.client_telephone || '').includes(searchTerm) ||
            (apt.prestation?.toLowerCase() || '').includes(searchTerm.toLowerCase())
        );
        const matchesStatus = statusFilter === 'all' || apt.statut === statusFilter;
        return matchesSearch && matchesStatus;
    });

    // --- File & Invoice Logic ---
    const openFileModal = (apt) => {
        setSelectedApt(apt);
        setFilesValues({ photos: [], facture: null });
        setGallerySelection([]);
    };

    const closeFileModal = () => {
        setSelectedApt(null);
        setFilesValues({ photos: [], facture: null });
        setGallerySelection([]);
    };

    const generateInvoice = (apt) => {
        const doc = new jsPDF();

        // Header
        doc.setFontSize(22);
        doc.setTextColor(37, 99, 235); // Blue
        doc.text("RoulezPropre", 20, 20);

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text("Facture générée automatiquement", 20, 26);
        doc.text(`Date: ${new Date().toLocaleDateString()}`, 150, 20);

        // Client Info
        doc.setFontSize(14);
        doc.setTextColor(0);
        doc.text("Client :", 20, 40);
        doc.setFontSize(12);
        doc.text(`Nom: ${apt.client_nom}`, 20, 50);
        doc.text(`Email: ${apt.client_email}`, 20, 56);
        doc.text(`Tel: ${apt.client_telephone}`, 20, 62);

        // Table
        autoTable(doc, {
            startY: 70,
            head: [['Description', 'Prix HT', 'TVA (20%)', 'Total TTC']],
            body: [
                [
                    apt.prestation,
                    `${(apt.prix * 0.83).toFixed(2)} €`,
                    `${(apt.prix * 0.17).toFixed(2)} €`,
                    `${apt.prix} €`
                ],
            ],
            theme: 'grid',
            headStyles: { fillColor: [37, 99, 235] }
        });

        const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 20 : 100;
        doc.setFontSize(14);
        doc.text(`Total à payer : ${apt.prix} €`, 130, finalY);

        doc.save(`Facture_${apt.client_nom}.pdf`);
    };

    const exportCSV = () => {
        const headers = ["Date", "Client", "Email", "Tel", "Prestation", "Prix", "Statut"];
        const rows = appointments.map(a => [
            new Date(a.date_heure).toLocaleDateString(),
            `"${a.client_nom}"`,
            a.client_email,
            a.client_telephone,
            `"${a.prestation}"`,
            a.prix,
            a.statut
        ]);
        const csvContent = "data:text/csv;charset=utf-8,"
            + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "roulezpropre_export.csv");
        document.body.appendChild(link);
        link.click();
    };

    const handleGalleryMerge = () => {
        if (gallerySelection.length !== 2) {
            alert("Veuillez sélectionner exactement 2 photos.");
            return;
        }
        // Logic handled in render or simple alert for now if canvas too complex inline?
        // Let's do a basic new window Open with both images side by side?
        // Or better: Simulate download.
        // For reliability in this code block:
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img1 = new Image();
        const img2 = new Image();

        // CORS proxy or fetch blob... PocketBase URL should be cross-origin accessible if configured.
        img1.crossOrigin = "Anonymous";
        img2.crossOrigin = "Anonymous";

        img1.src = getFileUrl(selectedApt, gallerySelection[0]);
        img2.src = getFileUrl(selectedApt, gallerySelection[1]);

        let loaded = 0;
        const draw = () => {
            loaded++;
            if (loaded === 2) {
                canvas.width = img1.width + img2.width;
                canvas.height = Math.max(img1.height, img2.height);
                ctx.drawImage(img1, 0, 0);
                ctx.drawImage(img2, img1.width, 0);

                // Add Logo/Text watermark
                ctx.font = "bold 40px Arial";
                ctx.fillStyle = "white";
                ctx.strokeStyle = "black";
                ctx.lineWidth = 2;
                ctx.fillText("RoulezPropre", 50, canvas.height - 50);
                ctx.strokeText("RoulezPropre", 50, canvas.height - 50);

                const link = document.createElement('a');
                link.download = `montage_${selectedApt.client_nom}.png`;
                link.href = canvas.toDataURL();
                link.click();
            }
        };
        img1.onload = draw;
        img2.onload = draw;
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!selectedApt) return;
        setUploading(true);

        const formData = new FormData();
        // Keep existing files
        if (selectedApt.photos_avant_apres) {
            const existing = Array.isArray(selectedApt.photos_avant_apres) ? selectedApt.photos_avant_apres : [selectedApt.photos_avant_apres];
            existing.forEach(f => formData.append('photos_avant_apres', f));
        }
        if (selectedApt.photo_avant) {
            const existing = Array.isArray(selectedApt.photo_avant) ? selectedApt.photo_avant : [selectedApt.photo_avant];
            existing.forEach(f => formData.append('photo_avant', f));
        }
        if (selectedApt.photo_apres) {
            const existing = Array.isArray(selectedApt.photo_apres) ? selectedApt.photo_apres : [selectedApt.photo_apres];
            existing.forEach(f => formData.append('photo_apres', f));
        }
        if (selectedApt.facture && !filesValues.facture) {
            formData.append('facture', selectedApt.facture);
        }

        if (filesValues.photos.length > 0) {
            for (let i = 0; i < filesValues.photos.length; i++) {
                const compressed = await compressImage(filesValues.photos[i]);
                formData.append('photos_avant_apres', compressed);
            }
        }
        if (filesValues.facture) {
            formData.append('facture', filesValues.facture);
        }

        // Handle Slider Homepage Fields
        if (filesValues.publier_home !== undefined) {
            formData.append('publier_home', filesValues.publier_home);
        }
        if (filesValues.project_category) {
            formData.append('project_category', filesValues.project_category);
        }

        // Handle Multiple Before/After Photos
        if (filesValues.photo_avant && filesValues.photo_avant.length > 0) {
            for (let i = 0; i < filesValues.photo_avant.length; i++) {
                const compressed = await compressImage(filesValues.photo_avant[i]);
                formData.append('photo_avant', compressed);
            }
        }
        if (filesValues.photo_apres && filesValues.photo_apres.length > 0) {
            for (let i = 0; i < filesValues.photo_apres.length; i++) {
                const compressed = await compressImage(filesValues.photo_apres[i]);
                formData.append('photo_apres', compressed);
            }
        }

        try {
            await pb.collection('rendez_vous').update(selectedApt.id, formData);
            alert("Fichiers envoyés avec succès !");
            closeFileModal();
            loadData();
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'envoi.");
        } finally {
            setUploading(false);
        }
    };

    const getFileUrl = (apt, filename) => pb.files.getUrl(apt, filename);

    if (loading) return <div className="admin-container">Chargement...</div>;

    return (
        <div className="admin-layout-wrapper">
            <aside className="admin-sidebar">
                <div className="sidebar-title">Menu Principal</div>
                <button className={`sidebar-btn ${currentView === 'dashboard' ? 'active' : ''}`} onClick={() => setCurrentView('dashboard')}>
                    <FaChartPie className="sidebar-icon" /> Dashboard
                </button>
                <button className={`sidebar-btn ${currentView === 'list' ? 'active' : ''}`} onClick={() => setCurrentView('list')}>
                    <FaList className="sidebar-icon" /> Liste RDV
                </button>
                <button className={`sidebar-btn ${currentView === 'calendar' ? 'active' : ''}`} onClick={() => setCurrentView('calendar')}>
                    <FaCalendarAlt className="sidebar-icon" /> Calendrier
                </button>
                <button className={`sidebar-btn ${currentView === 'crm' ? 'active' : ''}`} onClick={() => setCurrentView('crm')}>
                    <FaUsers className="sidebar-icon" /> Clients
                </button>
                <button className={`sidebar-btn ${currentView === 'services' ? 'active' : ''}`} onClick={() => setCurrentView('services')}>
                    <FaBriefcase className="sidebar-icon" /> Services & Tarifs
                </button>
                <button className={`sidebar-btn ${currentView === 'planning' ? 'active' : ''}`} onClick={() => setCurrentView('planning')}>
                    <FaCog className="sidebar-icon" /> Config. Horaires
                </button>
                <button className={`sidebar-btn ${currentView === 'projects' ? 'active' : ''}`} onClick={() => setCurrentView('projects')}>
                    <FaImages className="sidebar-icon" /> Réalisations
                </button>
                <button className={`sidebar-btn ${currentView === 'chat' ? 'active' : ''}`} onClick={() => setCurrentView('chat')}>
                    <FaComments className="sidebar-icon" /> Messages
                </button>
                <button className={`sidebar-btn ${currentView === 'map' ? 'active' : ''}`} onClick={() => setCurrentView('map')}>
                    <FaMapMarkedAlt className="sidebar-icon" /> Carte
                </button>
            </aside>

            <main className="admin-main-content">
                {/* --- ADMIN NAVBAR (PROPOSITION 1: GLASS) --- */}
                <nav className="admin-navbar-glass">
                    <div className="admin-navbar-left">
                        <button className="back-to-site-btn" onClick={() => navigate('/')}>
                            <FaArrowLeft /> <span>Voir le site</span>
                        </button>
                    </div>

                    <div className="admin-navbar-right">
                        <div className="admin-nav-icons-group">
                            {/* Theme Toggle */}
                            <button onClick={toggleTheme} className="admin-nav-icon-btn" title="Mode Sombre/Clair">
                                {theme === 'light' ? <FaMoon /> : <FaSun style={{ color: '#f59e0b' }} />}
                            </button>

                            {/* Notifications */}
                            <div className="admin-nav-item-wrapper" ref={notifRef}>
                                <button onClick={() => setIsNotifOpen(!isNotifOpen)} className="admin-nav-icon-btn" title="Notifications">
                                    <FaBell />
                                    <span className="notif-badge"></span>
                                </button>
                                {isNotifOpen && (
                                    <div className="admin-dropdown-menu notif-dropdown">
                                        <div className="dropdown-header">
                                            <span>Notifications</span>
                                            <button className="mark-read-btn">Tout lu</button>
                                        </div>
                                        <div className="dropdown-empty">
                                            <FaBell className="empty-icon" />
                                            <p>Aucune nouvelle notification</p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* User Avatar */}
                            <div className="admin-nav-item-wrapper" ref={userMenuRef}>
                                <button className="admin-avatar-btn" onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}>
                                    {user?.name ? user.name.charAt(0).toUpperCase() : (user?.email ? user.email.charAt(0).toUpperCase() : 'A')}
                                </button>
                                {isUserMenuOpen && (
                                    <div className="admin-dropdown-menu user-dropdown">
                                        <div className="dropdown-user-info">
                                            <strong>{user?.name || 'Administrateur'}</strong>
                                            <span>{user?.email}</span>
                                        </div>
                                        <button onClick={() => navigate('/profile')} className="dropdown-item">Mon Profil</button>
                                        <button onClick={logout} className="dropdown-item logout">Déconnexion</button>
                                    </div>
                                )}
                            </div>

                            {/* QR Code */}
                            <button onClick={() => setIsQrOpen(true)} className="admin-nav-icon-btn qr-btn" title="Scan & Book">
                                <FaQrcode />
                            </button>
                        </div>
                    </div>
                </nav>

                <div className="admin-container">

                    {/* Navigation Tabs */}
                    <div className="admin-tabs">
                        <button className={`tab-btn ${currentView === 'dashboard' ? 'active' : ''}`} onClick={() => setCurrentView('dashboard')}>
                            <FaChartPie /> Dashboard
                        </button>
                        <button className={`tab-btn ${currentView === 'list' ? 'active' : ''}`} onClick={() => setCurrentView('list')}>
                            <FaList /> Liste RDV
                        </button>
                        <button className={`tab-btn ${currentView === 'calendar' ? 'active' : ''}`} onClick={() => setCurrentView('calendar')}>
                            <FaCalendarAlt /> Calendrier
                        </button>
                        <button className={`tab-btn ${currentView === 'crm' ? 'active' : ''}`} onClick={() => setCurrentView('crm')}>
                            <FaUsers /> Clients
                        </button>
                        <button className={`tab-btn ${currentView === 'services' ? 'active' : ''}`} onClick={() => setCurrentView('services')}>
                            <FaBriefcase /> Services & Tarifs
                        </button>
                        <button className={`tab-btn ${currentView === 'planning' ? 'active' : ''}`} onClick={() => setCurrentView('planning')}>
                            <FaCog /> Config. Horaires
                        </button>
                        <button className={`tab-btn ${currentView === 'projects' ? 'active' : ''}`} onClick={() => setCurrentView('projects')}>
                            <FaImages /> Réalisations
                        </button>
                        <button className={`tab-btn ${currentView === 'chat' ? 'active' : ''}`} onClick={() => setCurrentView('chat')}>
                            <FaComments /> Messages
                        </button>
                        <button className={`tab-btn ${currentView === 'map' ? 'active' : ''}`} onClick={() => setCurrentView('map')}>
                            <FaMapMarkedAlt /> Carte
                        </button>
                    </div>

                    <div className="admin-view-content">

                        {/* 1. DASHBOARD */}
                        {currentView === 'dashboard' && <AdminDashboard appointments={appointments} />}

                        {/* 2. CALENDAR */}
                        {/* 2. CALENDAR */}
                        {currentView === 'calendar' && (
                            <div className="admin-section fade-in">
                                <AdminCalendar
                                    appointments={appointments}
                                    blockedDays={blockedDays}
                                    planningConfig={weekPlanning}
                                    onEventClick={(event) => setViewingApt(event.resource)}
                                    onBlockDate={async (date, reason) => {
                                        try {
                                            await pb.collection('fermetures').create({
                                                date: date.toISOString(),
                                                raison: reason
                                            }, { requestKey: null });
                                            alert(`Date bloquée : ${date.toLocaleDateString()}`);
                                            loadPlanningData();
                                        } catch (err) {
                                            console.error(err);
                                            alert("Erreur lors du blocage.");
                                        }
                                    }}
                                />
                            </div>
                        )}

                        {/* 3. MAP */}
                        {currentView === 'map' && <AdminMap appointments={appointments} />}


                        {/* 5. SERVICES */}
                        {currentView === 'services' && <AdminServices />}

                        {/* 6. CHAT */}
                        {currentView === 'chat' && <AdminChat />}

                        {/* 11. PLANNING & HORAIRES */}
                        {currentView === 'planning' && (
                            <div className="admin-section fade-in">
                                <div className="section-header-premium">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '20px' }}>
                                        <div>
                                            <h2 style={{ margin: 0 }}>⏰ Horaires d'ouverture</h2>
                                            <p className="text-muted">Définissez vos heures d'activité par défaut et gérez vos congés.</p>
                                        </div>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button className="btn-copy-all" onClick={applyMondayToAll} title="Appliquer les horaires du Lundi à toute la semaine">
                                                <FaPaperPlane /> Copier Lundi partout
                                            </button>
                                            <button className="save-btn" onClick={saveAllPlanning} disabled={uploading}>
                                                {uploading ? 'Enregistrement...' : 'Enregistrer tous les horaires'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="planning-grid-premium">
                                    {weekPlanning.length > 0 ? weekPlanning.map((day) => (
                                        <div key={day.id} className={`day-card-premium ${!day.ouvert ? 'closed' : ''}`}>
                                            <div className="day-header">
                                                <h4>{day.jour}</h4>
                                                <span className={`status-badge-day ${day.ouvert ? 'open' : 'closed'}`}>
                                                    {day.ouvert ? 'OUVERT' : 'FERMÉ'}
                                                </span>
                                            </div>

                                            <div className="time-inputs" style={{ opacity: day.ouvert ? 1 : 0.5 }}>
                                                <input
                                                    type="time"
                                                    disabled={!day.ouvert}
                                                    value={day.debut}
                                                    onChange={e => {
                                                        const updated = weekPlanning.map(d => d.id === day.id ? { ...d, debut: e.target.value } : d);
                                                        setWeekPlanning(updated);
                                                    }}
                                                />
                                                <span>à</span>
                                                <input
                                                    type="time"
                                                    disabled={!day.ouvert}
                                                    value={day.fin}
                                                    onChange={e => {
                                                        const updated = weekPlanning.map(d => d.id === day.id ? { ...d, fin: e.target.value } : d);
                                                        setWeekPlanning(updated);
                                                    }}
                                                />
                                            </div>

                                            <div className="day-actions">
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={day.ouvert}
                                                        onChange={e => {
                                                            const updated = weekPlanning.map(d => d.id === day.id ? { ...d, ouvert: e.target.checked } : d);
                                                            setWeekPlanning(updated);
                                                        }}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <span className="small-text">{day.ouvert ? 'Activé' : 'Désactivé'}</span>
                                            </div>
                                        </div>
                                    )) : (
                                        <div className="day-card-premium" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px' }}>
                                            <p>Veuillez initialiser la collection 'planning'.</p>
                                            <button className="btn-approve" onClick={initPlanning}>
                                                <FaPlus /> Initialiser (7 jours)
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="planning-card" style={{ marginTop: '40px' }}>
                                    <h3 style={{ marginBottom: '5px' }}>🚫 Blocage de dates (Congés / Périodes)</h3>
                                    <p className="text-muted" style={{ marginBottom: '20px' }}>Toute date bloquée sera retirée du calendrier de réservation client.</p>

                                    <div className="block-form-premium">
                                        <form onSubmit={handleBlockPeriod}>
                                            <div className="input-group-row" style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                                                <div style={{ flex: 1 }}>
                                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '700', fontSize: '0.8rem' }}>DATE DE DÉBUT</label>
                                                    <input
                                                        type="date"
                                                        className="search-input"
                                                        style={{ width: '100%' }}
                                                        required
                                                        value={newBlockedPeriod.dateDebut}
                                                        onChange={e => setNewBlockedPeriod({ ...newBlockedPeriod, dateDebut: e.target.value })}
                                                    />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '700', fontSize: '0.8rem' }}>DATE DE FIN (OPT.)</label>
                                                    <input
                                                        type="date"
                                                        className="search-input"
                                                        style={{ width: '100%' }}
                                                        value={newBlockedPeriod.dateFin}
                                                        onChange={e => setNewBlockedPeriod({ ...newBlockedPeriod, dateFin: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '700', fontSize: '0.8rem' }}>MOTIF DE FERMETURE</label>
                                                <input
                                                    type="text"
                                                    className="search-input"
                                                    placeholder="Ex: Vacances d'été, Repos hebdomadaire..."
                                                    value={newBlockedPeriod.raison}
                                                    onChange={e => setNewBlockedPeriod({ ...newBlockedPeriod, raison: e.target.value })}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                            <button className="save-btn btn-full" type="submit" disabled={uploading}>
                                                {uploading ? 'Traitement...' : 'Bloquer la période sélectionnée'}
                                            </button>
                                        </form>
                                    </div>

                                    <div className="nav-tabs-mini">
                                        <button className={`tab-mini ${blockedTab === 'upcoming' ? 'active' : ''}`} onClick={() => setBlockedTab('upcoming')}>
                                            Congés à venir ({blockedDays.filter(b => new Date(b.date) >= new Date().setHours(0, 0, 0, 0)).length})
                                        </button>
                                        <button className={`tab-mini ${blockedTab === 'history' ? 'active' : ''}`} onClick={() => setBlockedTab('history')}>
                                            Historique ({blockedDays.filter(b => new Date(b.date) < new Date().setHours(0, 0, 0, 0)).length})
                                        </button>
                                    </div>

                                    <div className="blocked-list-new">
                                        {blockedDays
                                            .filter(item => blockedTab === 'upcoming'
                                                ? new Date(item.date) >= new Date().setHours(0, 0, 0, 0)
                                                : new Date(item.date) < new Date().setHours(0, 0, 0, 0))
                                            .map(item => (
                                                <div key={item.id} className="blocked-item-new">
                                                    <div className="blocked-info">
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <h5>{new Date(item.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</h5>
                                                            {new Date(item.date) >= new Date().setHours(0, 0, 0, 0) && <span className="block-tag upcoming">À venir</span>}
                                                        </div>
                                                        <p>{item.raison || 'Aucun motif renseigné'}</p>
                                                    </div>
                                                    <button className="btn-reject btn-small" onClick={() => unblockDate(item.id)}>
                                                        <FaTrash /> Supprimer
                                                    </button>
                                                </div>
                                            ))}
                                        {blockedDays.filter(item => blockedTab === 'upcoming'
                                            ? new Date(item.date) >= new Date().setHours(0, 0, 0, 0)
                                            : new Date(item.date) < new Date().setHours(0, 0, 0, 0)).length === 0 && (
                                                <p className="text-muted" style={{ textAlign: 'center', padding: '20px' }}>Aucune date trouvée dans cette catégorie.</p>
                                            )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 7. NOTIFICATIONS (Live Lists) */}
                        {currentView === 'notifications' && (
                            <div className="admin-section fade-in">
                                <div className="planning-grid">
                                    <div className="planning-card">
                                        <h3> Rappels du Lendemain ({getRemindersTomorrow().length})</h3>
                                        <p className="text-muted">Clients ayant un RDV prévu demain.</p>
                                        <div className="blocked-list mt-3">
                                            {getRemindersTomorrow().map(apt => (
                                                <div key={apt.id} className="blocked-item">
                                                    <div>
                                                        <b>{apt.client_nom}</b><br />
                                                        <small>{new Date(apt.date_heure).getHours()}h{new Date(apt.date_heure).getMinutes() || '00'}</small>
                                                    </div>
                                                    <button
                                                        className="btn-approve"
                                                        onClick={() => {
                                                            const msg = `Bonjour ${apt.client_nom}, c'est RoulezPropre. Petit rappel pour votre RDV de demain à ${new Date(apt.date_heure).getHours()}h${new Date(apt.date_heure).getMinutes() || '00'}. À demain !`;
                                                            sendWhatsApp(apt.client_telephone, msg);
                                                        }}
                                                    >
                                                        <FaPaperPlane /> Relancer
                                                    </button>
                                                </div>
                                            ))}
                                            {getRemindersTomorrow().length === 0 && <p className="text-muted">Aucun rappel pour demain.</p>}
                                        </div>
                                    </div>

                                    <div className="planning-card">
                                        <h3>⭐ Demandes d'Avis (J+2) ({getReviewRequests().length})</h3>
                                        <p className="text-muted">Clients servis il y a 48 heures.</p>
                                        <div className="blocked-list mt-3">
                                            {getReviewRequests().map(apt => (
                                                <div key={apt.id} className="blocked-item">
                                                    <div>
                                                        <b>{apt.client_nom}</b><br />
                                                        <small>{apt.prestation}</small>
                                                    </div>
                                                    <button
                                                        className="btn-files"
                                                        onClick={() => {
                                                            const msg = `Bonjour ${apt.client_nom} ! Merci d'avoir choisi RoulezPropre. Si vous êtes satisfait, un petit avis Google nous aiderait beaucoup : https://g.page/roulezpropre/review. Merci !`;
                                                            sendWhatsApp(apt.client_telephone, msg);
                                                        }}
                                                    >
                                                        <FaStar /> Demander Avis
                                                    </button>
                                                </div>
                                            ))}
                                            {getReviewRequests().length === 0 && <p className="text-muted">Rien à demander aujourd'hui.</p>}
                                        </div>
                                    </div>

                                    <div className="planning-card" style={{ borderTop: '4px solid #ef4444' }}>
                                        <h3 style={{ color: '#ef4444' }}>📅 Relances Fidélisation ({getDormantClients().length})</h3>
                                        <p className="text-muted">Clients n'ayant pas commandé depuis +3 mois.</p>
                                        <div className="blocked-list mt-3">
                                            {getDormantClients().map(client => (
                                                <div key={client.tel} className="blocked-item">
                                                    <div>
                                                        <b>{client.name}</b><br />
                                                        <small>Dernier RDV : {client.date.toLocaleDateString()}</small>
                                                    </div>
                                                    <button
                                                        className="btn-approve"
                                                        style={{ backgroundColor: '#ef4444' }}
                                                        onClick={() => {
                                                            const msg = `Bonjour ${client.name}, j'espère que vous allez bien ! Déjà 3 mois depuis notre dernier passage pour votre ${client.prestation}. Un petit rafraîchissement pour la saison ? À bientôt ! Jérémie - RoulezPropre`;
                                                            sendWhatsApp(client.tel, msg);
                                                        }}
                                                    >
                                                        <FaPaperPlane /> Relancer
                                                    </button>
                                                </div>
                                            ))}
                                            {getDormantClients().length === 0 && <p className="text-muted">Tous vos clients sont à jour ! ✨</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 8. LIST (Table) */}
                        {currentView === 'list' && (
                            <div className="admin-section fade-in">
                                <div className="list-header">
                                    <h2>Gestion des Rendez-vous</h2>
                                    <div className="search-filters">
                                        <button onClick={exportCSV} className="btn-finish" style={{ marginRight: '10px' }}>
                                            <FaDownload /> CSV
                                        </button>
                                        <input
                                            type="text"
                                            placeholder="🔍 Rechercher..."
                                            value={searchTerm}
                                            onChange={e => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="filter-select">
                                            <option value="all">Tout voir</option>
                                            <option value="en_attente">En Attente</option>
                                            <option value="valide">Validés</option>
                                            <option value="termine">Terminés</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="admin-table">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Client</th>
                                                <th>Prestation</th>
                                                <th>Statut</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredAppointments.map(apt => (
                                                <tr key={apt.id} className={`status-${apt.statut}`}>
                                                    <td>{new Date(apt.date_heure).toLocaleString()}</td>
                                                    <td>
                                                        <div>{apt.client_nom}</div>
                                                        <div className="small-text">{apt.client_telephone} | {apt.client_email}</div>
                                                        {apt.numero_facture && <span className="small-text">Facture: #{apt.numero_facture}</span>}
                                                    </td>
                                                    <td>{apt.prestation} <br /> <strong>{apt.prix} €</strong></td>
                                                    <td><span className={`badge badge-${apt.statut}`}>{apt.statut}</span></td>
                                                    <td>
                                                        <div className="action-buttons-cell">
                                                            {apt.statut === 'en_attente' && (
                                                                <button
                                                                    onClick={() => updateStatus(apt.id, 'valide')}
                                                                    className="btn-approve btn-small"
                                                                    title="Valider le RDV"
                                                                >
                                                                    <FaCheck />
                                                                </button>
                                                            )}

                                                            {['en_attente', 'valide'].includes(apt.statut) && (
                                                                <button
                                                                    onClick={() => updateStatus(apt.id, 'refuse')}
                                                                    className="btn-reject btn-small"
                                                                    title="Refuser/Annuler"
                                                                    style={{ marginLeft: '5px' }}
                                                                >
                                                                    <FaTimes />
                                                                </button>
                                                            )}

                                                            <button onClick={() => openFileModal(apt)} className="btn-files btn-small" title="Gérer fichiers" style={{ marginLeft: '5px' }}>
                                                                <FaFileUpload />
                                                            </button>

                                                            {apt.statut === 'valide' && (
                                                                <button
                                                                    onClick={() => updateStatus(apt.id, 'termine')}
                                                                    className="btn-finish btn-small"
                                                                    style={{ marginLeft: '5px' }}
                                                                    title="Terminer & Facturer"
                                                                >
                                                                    <FaCheck /> Finir
                                                                </button>
                                                            )}
                                                            <button 
                                                                onClick={() => generateInvoice(apt)} 
                                                                className="btn-finish btn-small" 
                                                                style={{ marginLeft: '5px', backgroundColor: '#6366f1' }} 
                                                                title="Générer Facture PDF"
                                                            >
                                                                <FaFileInvoice />
                                                            </button>

                                                            <button 
                                                                onClick={() => setViewingApt(apt)} 
                                                                className="btn-files btn-small" 
                                                                style={{ marginLeft: '5px', backgroundColor: '#94a3b8' }} 
                                                                title="Inspecter Détails"
                                                            >
                                                                <FaSearch />
                                                            </button>
                                                        </div>

                                                        <div className="file-indicators">
                                                            {apt.photos_avant_apres?.length > 0 && <span>📸{apt.photos_avant_apres.length}</span>}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* 8. CRM */}
                        {currentView === 'crm' && (
                            <div className="admin-section fade-in">
                                <h2>👥 Gestion Clients</h2>
                                <div className="crm-stats" style={{ marginBottom: '15px', color: '#64748b', fontSize: '0.9rem' }}>
                                    Total: <b>{users.length}</b> utilisateurs inscrits (dont {users.filter(u => u.role === 'admin').length} admin)
                                </div>
                                <table className="admin-table">
                                    <thead>
                                        <tr><th>Nom</th><th>Email</th><th>Téléphone</th><th>Code Parrainage</th><th>Bonus</th><th>Actions</th></tr>
                                    </thead>
                                    <tbody>
                                        {users.filter(u => u.role !== 'admin').map(u => (
                                            <tr key={u.id}>
                                                <td>{u.name || 'Sans Nom'}</td>
                                                <td>{u.email}</td>
                                                <td>{u.telephone || '-'}</td>
                                                <td><code style={{ background: '#f1f5f9', padding: '2px 6px', borderRadius: '4px' }}>{u.referral_code || '-'}</code></td>
                                                <td>{editingUser === u.id ? <input type="number" value={bonusPoints} onChange={e => setBonusPoints(Number(e.target.value))} className="small-input" /> : u.points_bonus || 0} pts</td>
                                                <td>
                                                    {editingUser === u.id ?
                                                        <button onClick={() => saveBonusPoints(u.id)} className="btn-approve"><FaSave /></button> :
                                                        <button onClick={() => handleEditUser(u)} className="btn-files"><FaUserEdit /></button>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                        {users.filter(u => u.role !== 'admin').length === 0 && (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>
                                                    <div style={{ fontSize: '2rem', marginBottom: '10px' }}>👥</div>
                                                    <p>Aucun client (utilisateur) trouvé dans la base de données.</p>
                                                    <small>Note: Seuls les clients ayant créé un compte apparaissent ici.<br/>Les rendez-vous anonymes sont dans la "Liste RDV".</small>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* 9. PROJECTS / REALISATIONS */}
                        {currentView === 'projects' && (
                            <div className="admin-section fade-in">
                                <div className="list-header">
                                    <h2>✨ Galerie des Réalisations</h2>
                                    <button className="btn-files" onClick={() => setIsCreatingProject(true)} style={{ marginLeft: 'auto' }}>
                                        <FaPlus /> Nouveau Projet
                                    </button>
                                </div>
                                <p className="text-muted" style={{ width: '100%', marginBottom: '20px' }}>Gérez ici les photos Avant/Après qui apparaissent sur le site.</p>

                                <table className="admin-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '40px' }}></th>
                                            <th>Date</th>
                                            <th>Catégorie</th>
                                            <th>Client / Prestation</th>
                                            <th>Photos</th>
                                            <th>En ligne ?</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <Reorder.Group
                                        as="tbody"
                                        axis="y"
                                        values={projects}
                                        onReorder={saveNewOrder}
                                    >
                                        {projects.map(proj => (
                                            <ProjectRow
                                                key={proj.id}
                                                proj={proj}
                                                pb={pb}
                                                handleEditProject={handleEditProject}
                                                loadProjects={loadProjects}
                                            />
                                        ))}
                                        {projects.length === 0 && (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>
                                                    Aucune réalisation trouvée. Créez-en une !
                                                </td>
                                            </tr>
                                        )}
                                    </Reorder.Group>
                                </table>
                            </div>
                        )}
                    </div>

                    {/* DETAIL MODAL */}
                    <AnimatePresence>
                        {viewingApt && (
                            <div className="modal-overlay" onClick={() => setViewingApt(null)}>
                                <motion.div 
                                    className="modal-content detail-modal-premium" 
                                    onClick={e => e.stopPropagation()}
                                    initial={{ scale: 0.9, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    exit={{ scale: 0.9, opacity: 0 }}
                                >
                                    <div className="modal-header">
                                        <h3><FaList /> Détails de la Réservation</h3>
                                        <button onClick={() => setViewingApt(null)} className="close-btn"><FaTimes /></button>
                                    </div>

                                    <div className="detail-grid">
                                        <section className="detail-section">
                                            <h4>👤 Informations Client</h4>
                                            <div className="detail-info-card">
                                                <p><strong>Nom :</strong> {viewingApt.client_nom}</p>
                                                <p><strong>Email :</strong> {viewingApt.client_email}</p>
                                                <p><strong>Téléphone :</strong> {viewingApt.client_telephone}</p>
                                                <div className="detail-actions-inline">
                                                    <button className="btn-approve btn-small" onClick={() => sendWhatsApp(viewingApt.client_telephone, `Bonjour ${viewingApt.client_nom}, c'est RoulezPropre...`)}>WhatsApp</button>
                                                    <a href={`tel:${viewingApt.client_telephone}`} className="btn-files btn-small" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>Appeler</a>
                                                </div>
                                            </div>
                                        </section>

                                        <section className="detail-section">
                                            <h4>📅 Rendez-vous & Lieu</h4>
                                            <div className="detail-info-card">
                                                <p><strong>Date :</strong> {new Date(viewingApt.date_heure).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}</p>
                                                <p><strong>Heure :</strong> {new Date(viewingApt.date_heure).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</p>
                                                <p><strong>Adresse :</strong> {viewingApt.adresse}</p>
                                                <p><strong>Statut :</strong> <span className={`badge badge-${viewingApt.statut}`}>{viewingApt.statut}</span></p>
                                            </div>
                                        </section>

                                        <section className="detail-section full-width">
                                            <h4>🛠️ Prestation & Options</h4>
                                            <div className="detail-info-card">
                                                <p className="prestation-main-title">{viewingApt.prestation}</p>
                                                <div className="options-text-area">
                                                    {viewingApt.options ? viewingApt.options.split('|').map((opt, i) => (
                                                        <div key={i} className="option-line-detail">{opt.trim()}</div>
                                                    )) : "Aucune option enregistrée."}
                                                </div>
                                            </div>
                                        </section>

                                        <section className="detail-section">
                                            <h4>💰 Détail du Prix</h4>
                                            <div className="detail-info-card price-details-card">
                                                <div className="price-row"><span>Base/Options :</span> <span>{viewingApt.prix + (viewingApt.remise_montant || 0) - (viewingApt.frais_deplacement || 0)} €</span></div>
                                                {viewingApt.frais_deplacement > 0 && <div className="price-row"><span>Déplacement :</span> <span>+{viewingApt.frais_deplacement} €</span></div>}
                                                {viewingApt.remise_montant > 0 && <div className="price-row text-danger"><span>Remise :</span> <span>-{viewingApt.remise_montant} €</span></div>}
                                                <div className="price-row total-row"><span>TOTAL :</span> <span>{viewingApt.prix} €</span></div>
                                            </div>
                                        </section>

                                        {viewingApt.photos_avant_apres?.length > 0 && (
                                            <section className="detail-section">
                                                <h4>📸 Photo Diagnostic</h4>
                                                <div className="detail-info-card photo-diag-card">
                                                    <img 
                                                        src={pb.files.getUrl(viewingApt, viewingApt.photos_avant_apres[0])} 
                                                        alt="Diagnostic" 
                                                        onClick={() => window.open(pb.files.getUrl(viewingApt, viewingApt.photos_avant_apres[0]), '_blank')}
                                                    />
                                                </div>
                                            </section>
                                        )}
                                    </div>

                                    <div className="modal-footer">
                                        <button onClick={() => { openFileModal(viewingApt); setViewingApt(null); }} className="btn-files" style={{ marginRight: 'auto' }}>
                                            <FaFileUpload /> Gérer fichiers
                                        </button>
                                        <button onClick={() => setViewingApt(null)} className="btn-reject">Fermer</button>
                                        {viewingApt.statut === 'en_attente' && (
                                            <button onClick={() => { updateStatus(viewingApt.id, 'valide'); setViewingApt(null); }} className="btn-approve">Valider le RDV</button>
                                        )}
                                    </div>
                                </motion.div>
                            </div>
                        )}
                    </AnimatePresence>

                    {/* CREATE PROJECT MODAL */}
                    {isCreatingProject && (
                        <div className="modal-overlay" onClick={() => setIsCreatingProject(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <div className="modal-header">
                                    <h3>{editingProject ? 'Modifier la Réalisation' : 'Nouveau Projet / Réalisation'}</h3>
                                    <button onClick={() => { setIsCreatingProject(false); setEditingProject(null); }} className="close-btn"><FaTimes /></button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={editingProject ? handleUpdateProject : handleCreateProject} className="upload-form">
                                        <div className="form-group">
                                            <label>Titre de la Prestation (ex: Rénovation Sièges)</label>
                                            <input
                                                type="text"
                                                className="search-input"
                                                style={{ width: '100%' }}
                                                value={newProjectData.prestation}
                                                onChange={e => setNewProjectData({ ...newProjectData, prestation: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Nom du Client (Optionnel)</label>
                                            <input
                                                type="text"
                                                className="search-input"
                                                style={{ width: '100%' }}
                                                value={newProjectData.client_nom}
                                                onChange={e => setNewProjectData({ ...newProjectData, client_nom: e.target.value })}
                                            />
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                            <div className="form-group">
                                                <label style={{ color: '#ef4444' }}>🔴 État Initial (1/ligne)</label>
                                                <textarea
                                                    className="search-input"
                                                    style={{ width: '100%', height: '100px', fontSize: '0.85rem' }}
                                                    value={newProjectData.liste_avant}
                                                    onChange={e => setNewProjectData({ ...newProjectData, liste_avant: e.target.value })}
                                                    placeholder="- Sièges encrassés&#10;- Taches de gras"
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label style={{ color: '#10b981' }}>🟢 Résultat Final (1/ligne)</label>
                                                <textarea
                                                    className="search-input"
                                                    style={{ width: '100%', height: '100px', fontSize: '0.85rem' }}
                                                    value={newProjectData.liste_apres}
                                                    onChange={e => setNewProjectData({ ...newProjectData, liste_apres: e.target.value })}
                                                    placeholder="- Cuir nourri&#10;- Habitacle assaini"
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Expertise / Tags (séparer par virgule)</label>
                                            <input
                                                type="text"
                                                className="search-input"
                                                style={{ width: '100%' }}
                                                value={newProjectData.tags}
                                                onChange={e => setNewProjectData({ ...newProjectData, tags: e.target.value })}
                                                placeholder="Vapeur, Cuir, Shampouinage..."
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Date</label>
                                            <input
                                                type="datetime-local"
                                                className="search-input"
                                                style={{ width: '100%' }}
                                                value={newProjectData.date_heure}
                                                onChange={e => setNewProjectData({ ...newProjectData, date_heure: e.target.value })}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Catégorie</label>
                                            <select
                                                className="filter-select"
                                                style={{ width: '100%' }}
                                                value={newProjectData.project_category}
                                                onChange={e => setNewProjectData({ ...newProjectData, project_category: e.target.value })}
                                            >
                                                <option value="auto">🚗 Auto</option>
                                                <option value="mobilier">🛋️ Mobilier</option>
                                            </select>
                                        </div>

                                        <fieldset className="upload-group" style={{ borderColor: '#ec4899' }}>
                                            <legend style={{ color: '#ec4899' }}>📸 Photos</legend>
                                            <div className="checkbox-row">
                                                <input
                                                    type="checkbox"
                                                    id="new_publier_home"
                                                    checked={newProjectData.publier_home}
                                                    onChange={e => setNewProjectData({ ...newProjectData, publier_home: e.target.checked })}
                                                />
                                                <label htmlFor="new_publier_home" style={{ fontWeight: 'bold' }}>Publier immédiatement ?</label>
                                            </div>

                                            <div className="photo-pairs-container">
                                                {newProjectData.photo_pairs.map((pair, index) => (
                                                    <div key={pair.id} className="pair-row fade-in">
                                                        <button type="button" className="remove-pair-btn" title="Supprimer ce binôme" onClick={() => removePhotoPair(pair.id)}>
                                                            <FaTimes />
                                                        </button>

                                                        <div className="pair-slot">
                                                            <label>🔴 État Initial</label>
                                                            <label className={`pair-drop-zone ${pair.avant ? 'has-file' : ''}`}>
                                                                {pair.avant ? (
                                                                    <>
                                                                        <img src={pair.typeAvant === 'existing' ? pb.files.getUrl(editingProject, pair.avant) : URL.createObjectURL(pair.avant)} alt="Avant" />
                                                                        <button type="button" className="remove-thumb-btn" onClick={(e) => { e.preventDefault(); removeFileFromPair(pair.id, 'avant'); }}><FaTimes /></button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FaCloudUploadAlt className="up-icon" />
                                                                        <span>Avant</span>
                                                                        <input type="file" onChange={(e) => updatePairFile(pair.id, 'avant', e.target.files[0])} accept="image/*" />
                                                                    </>
                                                                )}
                                                            </label>
                                                        </div>

                                                        <div className="pair-slot">
                                                            <label>🟢 Résultat Final</label>
                                                            <label className={`pair-drop-zone theme-apres ${pair.apres ? 'has-file' : ''}`}>
                                                                {pair.apres ? (
                                                                    <>
                                                                        <img src={pair.typeApres === 'existing' ? pb.files.getUrl(editingProject, pair.apres) : URL.createObjectURL(pair.apres)} alt="Apres" />
                                                                        <button type="button" className="remove-thumb-btn" onClick={(e) => { e.preventDefault(); removeFileFromPair(pair.id, 'apres'); }}><FaTimes /></button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FaFileUpload className="up-icon" />
                                                                        <span>Après</span>
                                                                        <input type="file" onChange={(e) => updatePairFile(pair.id, 'apres', e.target.files[0])} accept="image/*" />
                                                                    </>
                                                                )}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}

                                                <button type="button" className="add-pair-btn" onClick={addPhotoPair}>
                                                    <FaPlus /> Ajouter une transformation (Binôme Avant/Après)
                                                </button>
                                            </div>
                                        </fieldset>

                                        <button type="submit" className="save-btn btn-full" disabled={uploading}>
                                            {uploading ? 'Enregistrement...' : (editingProject ? 'Enregistrer les modifications' : 'Créer le Projet')}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* MODAL (Existing logic preserved) */}
                    {selectedApt && (
                        <div className="modal-overlay" onClick={closeFileModal}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <div className="modal-header">
                                    <h3>Fichiers: {selectedApt.client_nom}</h3>
                                    <button onClick={closeFileModal} className="close-btn"><FaTimes /></button>
                                </div>
                                <div className="modal-body">
                                    <div className="existing-files">
                                        <h4>Actuels :</h4>
                                        <div className="file-list">
                                            {selectedApt.photos_avant_apres && (Array.isArray(selectedApt.photos_avant_apres) ? selectedApt.photos_avant_apres : [selectedApt.photos_avant_apres]).map((photo, i) => (
                                                <div key={i} className="file-preview"
                                                    style={{ position: 'relative', cursor: 'pointer', border: gallerySelection.includes(photo) ? '2px solid blue' : '1px solid #cbd5e1' }}
                                                    onClick={() => {
                                                        if (gallerySelection.includes(photo)) {
                                                            setGallerySelection(prev => prev.filter(p => p !== photo));
                                                        } else {
                                                            if (gallerySelection.length < 2) setGallerySelection(prev => [...prev, photo]);
                                                        }
                                                    }}
                                                >
                                                    <img src={getFileUrl(selectedApt, photo)} alt="Thb" />
                                                    {gallerySelection.includes(photo) && <div style={{ position: 'absolute', top: 0, right: 0, background: 'blue', color: 'white', padding: '2px' }}><FaCheckSquare /></div>}
                                                </div>
                                            ))}
                                            {selectedApt.facture && <div className="file-preview doc-preview"><FaFileInvoice /> PDF</div>}
                                        </div>
                                        {gallerySelection.length === 2 && (
                                            <button onClick={handleGalleryMerge} style={{ marginTop: '10px', background: '#ec4899', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <FaImages /> Créer Montage Avant/Après
                                            </button>
                                        )}
                                    </div>
                                    <button className="btn-finish" onClick={() => generateInvoice(selectedApt)} style={{ width: '100%', marginBottom: '15px' }}>
                                        <FaFileInvoice /> Générer & Télécharger Facture
                                    </button>
                                    <form onSubmit={handleUpload} className="upload-form">
                                        <fieldset className="upload-group">
                                            <legend>📁 Espace Client</legend>

                                            <div className="upload-flex-container">
                                                <div className="upload-box-wrapper">
                                                    <label><FaCamera /> Photos du Chantier</label>
                                                    <label className={`custom-upload-zone ${filesValues.photos?.length > 0 ? 'has-files' : ''}`}>
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={e => setFilesValues({ ...filesValues, photos: e.target.files })}
                                                        />
                                                        <FaCloudUploadAlt className="up-icon" />
                                                        <span>{filesValues.photos?.length > 0 ? `${filesValues.photos.length} photos sélectionnées` : 'Glissez ou cliquez ici'}</span>
                                                        <small>Format: JPG, PNG</small>
                                                    </label>
                                                </div>

                                                <div className="upload-box-wrapper">
                                                    <label><FaFileInvoice /> Ajouter Facture (PDF)</label>
                                                    <label className={`custom-upload-zone ${filesValues.facture ? 'has-files' : ''}`}>
                                                        <input
                                                            type="file"
                                                            accept=".pdf"
                                                            onChange={e => setFilesValues({ ...filesValues, facture: e.target.files[0] })}
                                                        />
                                                        <FaFileInvoice className="up-icon" />
                                                        <span>{filesValues.facture ? filesValues.facture.name : 'Glissez votre PDF ici'}</span>
                                                        <small>Max 5 Mo</small>
                                                    </label>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset className="upload-group" style={{ borderColor: '#ec4899' }}>
                                            <legend style={{ color: '#ec4899' }}>✨ Slider Accueil / Projets</legend>

                                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                                <label style={{ color: '#ec4899', fontWeight: '800' }}>Catégorie du Projet</label>
                                                <select
                                                    value={filesValues.project_category || 'auto'}
                                                    onChange={e => setFilesValues({ ...filesValues, project_category: e.target.value })}
                                                    className="filter-select"
                                                    style={{ width: '100%', marginTop: '5px' }}
                                                >
                                                    <option value="auto">🚗 Auto</option>
                                                    <option value="mobilier">🛋️ Mobilier</option>
                                                </select>
                                            </div>

                                            <div className="checkbox-row" style={{ marginBottom: '20px' }}>
                                                <input
                                                    type="checkbox"
                                                    id="publier_home"
                                                    checked={filesValues.publier_home || false}
                                                    onChange={e => setFilesValues({ ...filesValues, publier_home: e.target.checked })}
                                                />
                                                <label htmlFor="publier_home" style={{ fontWeight: 'bold' }}>Publier ce chantier sur l'accueil ?</label>
                                            </div>

                                            <div className="upload-flex-container">
                                                <div className="upload-box-wrapper">
                                                    <label>Photos AVANT</label>
                                                    <label className={`custom-upload-zone ${filesValues.photo_avant?.length > 0 ? 'has-files' : ''}`}>
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={e => setFilesValues({ ...filesValues, photo_avant: e.target.files })}
                                                        />
                                                        <FaCamera className="up-icon" />
                                                        <span>{filesValues.photo_avant?.length > 0 ? `${filesValues.photo_avant.length} photos` : 'Côté AVANT'}</span>
                                                    </label>
                                                </div>

                                                <div className="upload-box-wrapper">
                                                    <label>Photos APRÈS</label>
                                                    <label className={`custom-upload-zone theme-apres ${filesValues.photo_apres?.length > 0 ? 'has-files' : ''}`}>
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={e => setFilesValues({ ...filesValues, photo_apres: e.target.files })}
                                                        />
                                                        <FaCamera className="up-icon" />
                                                        <span>{filesValues.photo_apres?.length > 0 ? `${filesValues.photo_apres.length} photos` : 'Côté APRÈS'}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <button type="submit" className="save-btn btn-full" disabled={uploading}>Enregistrer & Envoyer</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* 10. MODAL SIGNATURE */}
                    {signingApt && (
                        <div className="modal-overlay">
                            <div className="modal-content" style={{ width: '450px' }}>
                                <div className="modal-header">
                                    <h3>🚀 Clôture & Avis Google</h3>
                                    <button className="close-btn" onClick={() => setSigningApt(null)}><FaTimes /></button>
                                </div>
                                <div className="modal-body" style={{ textAlign: 'center' }}>
                                    <h4 style={{ color: '#16a34a', marginBottom: '10px' }}>✨ Travail Terminé !</h4>
                                    <p className="text-muted">Proposez au client de scanner ce code pour laisser un avis pendant que vous clôturez.</p>
                                    
                                    <div style={{ 
                                        background: 'white', 
                                        padding: '20px', 
                                        borderRadius: '20px', 
                                        display: 'inline-block', 
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                        margin: '20px 0'
                                    }}>
                                        <QRCodeCanvas 
                                            value="https://g.page/roulezpropre/review" 
                                            size={200}
                                            level={"H"}
                                            includeMargin={true}
                                        />
                                    </div>

                                    <div style={{ marginTop: '10px', marginBottom: '20px' }}>
                                        <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#1e293b' }}>
                                            ⭐ Google My Business
                                        </div>
                                        <div style={{ fontSize: '0.8rem', color: '#64748b' }}>
                                            Faites grimper votre note !
                                        </div>
                                    </div>

                                    <button
                                        className="save-btn btn-full"
                                        onClick={handleTerminate}
                                        disabled={uploading}
                                        style={{ background: '#1e293b' }}
                                    >
                                        {uploading ? 'Envoi...' : 'Valider la clôture & Facturer'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </main>

            {/* QR Code Lightbox */}
            <AnimatePresence>
                {isQrOpen && (
                    <motion.div
                        className="qr-lightbox-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setIsQrOpen(false)}
                        style={{ zIndex: 9999 }}
                    >
                        <motion.div
                            className="qr-lightbox-card"
                            initial={{ scale: 0.8, opacity: 0, y: 20 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.8, opacity: 0, y: 20 }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button className="qr-lightbox-close" onClick={() => setIsQrOpen(false)}>
                                <FaTimes />
                            </button>

                            <div className="qr-lightbox-content">
                                <div className="qr-lightbox-header">
                                    <div className="logo-circle large">RP</div>
                                    <h3>Réservation Instantanée</h3>
                                    <p>Pointez votre appareil photo sur l'écran pour scanner</p>
                                </div>

                                <div className="qr-large-container">
                                    <img
                                        src="https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://roulezpropre.fr/reservation&color=1f2937"
                                        alt="QR Reservation Large"
                                    />
                                    <div className="qr-corner tl"></div>
                                    <div className="qr-corner tr"></div>
                                    <div className="qr-corner bl"></div>
                                    <div className="qr-corner br"></div>
                                </div>

                                <div className="qr-lightbox-footer">
                                    <span className="qr-link-text">roulezpropre.fr/reservation</span>
                                    <div className="qr-status-badge">
                                        <span className="status-dot"></span>
                                        QR Code Sécurisé
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

// Sub-components for better drag control
const ProjectRow = ({ proj, pb, handleEditProject, loadProjects }) => {
    const controls = useDragControls();
    return (
        <Reorder.Item
            as="tr"
            value={proj}
            dragListener={false}
            dragControls={controls}
            className={proj.publier_home ? 'highlight-row' : ''}
        >
            <td className="drag-handle-cell" onPointerDown={(e) => controls.start(e)}>
                <FaGripVertical className="drag-handle-icon" />
            </td>
            <td>{proj.date ? new Date(proj.date).toLocaleDateString() : '-'}</td>
            <td>{proj.categorie === 'mobilier' ? '🛋️ Mobilier' : '🚗 Auto'}</td>
            <td>
                <strong>{proj.client_nom || 'Projet'}</strong><br />
                <small>{proj.titre}</small>
            </td>
            <td>
                <div className="mini-previews-admin">
                    <div className="preview-side">
                        <small className="side-tag avant">AVANT</small>
                        <div className="thumb-stack">
                            {proj.photo_avant && (Array.isArray(proj.photo_avant) ? proj.photo_avant : [proj.photo_avant]).slice(0, 1).map((img, i) => (
                                <img key={i} src={pb.files.getURL(proj, img)} alt="avant" className="admin-list-thumb" />
                            ))}
                        </div>
                    </div>
                    <div className="preview-side">
                        <small className="side-tag apres">APRÈS</small>
                        <div className="thumb-stack">
                            {proj.photo_apres && (Array.isArray(proj.photo_apres) ? proj.photo_apres : [proj.photo_apres]).slice(0, 1).map((img, i) => (
                                <img key={i} src={pb.files.getURL(proj, img)} alt="apres" className="admin-list-thumb" />
                            ))}
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <button
                    className={`toggle-btn ${proj.publier_home ? 'active' : ''}`}
                    onClick={async () => {
                        await pb.collection('realisations').update(proj.id, { publier_home: !proj.publier_home });
                        loadProjects();
                    }}
                >
                    {proj.publier_home ? 'OUI' : 'NON'}
                </button>
            </td>
            <td>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button className="btn-finish" style={{ backgroundColor: '#2563eb' }} onClick={() => handleEditProject(proj)}><FaUserEdit /></button>
                    <button className="btn-finish" style={{ backgroundColor: '#ef4444' }} onClick={async () => {
                        if (window.confirm('Supprimer ?')) {
                            await pb.collection('realisations').delete(proj.id);
                            loadProjects();
                        }
                    }}><FaTrash /></button>
                </div>
            </td>
        </Reorder.Item>
    );
};

export default AdminPage;
